import styled from "styled-components";
import { BiError } from "react-icons/bi";

const StyledErrorLink = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  font-size: 3rem;
  flex-wrap: wrap;

  svg {
    font-size: 15rem;
    margin-bottom: 2rem;
  }

  h2 {
    text-align: center;
    margin-bottom: 2rem;
    padding: 0 2rem;
  }

  a,
  a:active,
  a:visited {
    color: inherit;
  }
`;

function ErrorLink() {
  return (
    <StyledErrorLink>
      <BiError />
      <h2>
        Page not found. Please back to the <a href="/">home page</a>
      </h2>
    </StyledErrorLink>
  );
}

export default ErrorLink;
